<template>
  <div class="home-box">
    <div class="box">
      <div class="box-title">
        “{{name}}”专项答题
        <div @click="enter"><i class="el-icon-back"></i> 返回</div>
      </div>
      <div class="scroll" style="height: 83vh;">
        <div class="zw" v-if="dataList==0">暂无题目</div>
        <div class="s-l">
          <div class="s-l-i" v-for="(item,index) in dataList">
            <div class="a-title">
              <span style="margin-left:12px" v-if="item.questType==1">单选题</span>
              <span style="margin-left:12px" v-if="item.questType==2">多选题</span>
              <span style="margin-left:12px" v-if="item.questType==3">判断题</span>
              </div>
            <div class="a-row">
              <div class="a-row-l">{{index+1}}</div>
              <div class="a-row-r">{{item.questWord}}</div>
            </div>
            <div class="a-row1">
              <el-radio :disabled="disabled" @change="bbb(item)" v-if="item.questType==1" v-model="item.radio" v-for="child in item.options" :label="child.opOption"><span class="a-row-item">{{child.opOption}}、{{child.opWord}}</span></el-radio>
              <el-checkbox-group :disabled="disabled" @change="bbb(item)" v-if="item.questType==2" v-model="item.radio">
                <el-checkbox v-for="child in item.options" :label="child.opOption">{{child.opOption+'、'+child.opWord}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-show="indexA==1" class="a-row">
              <div class=""></div>
              <div class="a-row-r"><span :style="item.color=='red'?'color:red;':'color:#30980D'">{{item.color=='red'?'错误':'正确'}}</span></div>
            </div>
            <div v-show="indexA==1" class="a-row">
              <div class=""></div>
              <div class="a-row-r">正确答案：{{item.answer}}</div>
            </div>
            <div v-show="indexA==1" class="a-row">
              <div class=""></div>
              <div class="a-row-r">答案解析：{{item.questAnalysis}}</div>
            </div>
          </div>
        </div>
        <div v-if="dataList.length!=0" class="s-r">
          <div class="s-r-b">
            <div class="s-r-b-t">
              <div class="s-r-b-t-l">答题卡</div>
              <div class="s-r-b-t-l">用时：{{date==''?'00:00:00':date}}</div>
            </div>
            <div class="s-r-b-b">
              <div :class=" item.color" v-for="(item,index) in dataList">
                {{index+1}}
              </div>
            </div>
          </div>
          <div class="btn" v-show="disabled" @click="startExam">开始考试</div>
          <div class="btn" v-show="!disabled" @click="aaa">提交</div>
        </div>
        <el-dialog
          title=""
          :before-close="qx"
          :visible.sync="dialogVisible"
          width="30%">
          <div class="dialog-cont">
            <span style="font-size:28px;margin-top:3vh;display:flex;justify-content: center;">{{userName.name}}您的本次考试结果！</span>
             <br>
          <span style="font-size:28px;color:#30980D;margin-top:2vh;display:flex;justify-content: center;">本次用时{{date}}</span>
            <br>
          <span style="font-size:28px;color:#30980D;margin-top:2vh;display:flex;justify-content: center;">正确率：{{num}}%</span>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="qx">核验答案</el-button>
            <el-button type="primary" @click="zlyc">再来一次</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
  export default {
    data() {
      return {
        search:{
          storeId:'',
          groupId:util.session.get('groupId'),
          storeType:3
        },
        dataList:[],
        aa:base.httpCtx,
        noDone:[],
        dialogVisible:false,
        num:'',
        userName:util.session.get('user'),
        disabled:true,
        date:'',
        time:null,
        indexA:0,
        name:''
      }
    },
    mounted(){
      this.name=this.$route.query.name
      this.search.storeId=this.$route.query.storeId
      this.getRandomQuestion()
      if(this.time!=null){
        clearInterval(this.time)
      }
    },
    beforeDestroy(){
      if(this.time!=null){
        clearInterval(this.time)
      }
    },
    methods:{
      enter(){
        if(this.time==null){
        this.$router.replace({
              path:'/answerExercises',
              query:{
                pageSize:this.$route.query.pageSize,
              pageNum:this.$route.query.pageNum,
              }
            })
        }else{
          this.$confirm('切换将丢失本次考试数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            clearInterval(this.time)
            this.$router.replace({
              path:'/answerExercises',
              query:{
                pageSize:this.$route.query.pageSize,
              pageNum:this.$route.query.pageNum,
              },
            })
          }).catch(() => {         
          })
        }
      },
      listItem(item){
        console.log(item)
      },
      handleSizeChange(val){
        this.search1.pageSize = val
        this.search1.pageNum = 1
        this.getData()
      },
      handleCurrentChange(val){
        this.search1.pageNum = val
        this.getData()
      },
      getData(){
            var that = this;
            myHttp.getStoreList(this.search1).then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.pageInfo.list||[];
                    console.log(resp)
                    that.total = resp.data.data.pageInfo.total||0;
                    list.forEach((item,index)=>{
                      item.index = (that.search1.pageNum-1)*that.search1.pageSize+index+1
                    })
                    that.listData = list;
                    console.log(that.listData)
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                }else{
                that.$message.error(resp.data.msg);
                that.dataText = "暂无数据"
                }
            },function(){});
        },
      qx(){
        this.dialogVisible=false
        this.disabled=true
        this.indexA=1
      },
      zlyc(){
        this.indexA=0
        this.dialogVisible=false
        this.getRandomQuestion()
        this.date=''
        this.startExam()
      },
      startExam(){
        if(this.indexA==1){
          this.$confirm('是否重新考试?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.zlyc()
          }).catch(() => {         
          });
        }else{
          this.disabled=false
          this.$message({
            type:'success',
            message:'考试开始！'
          })
          let a = 0
          let b = 0
          let c = 0
          let aa = 0
          let bb = 0
          let cc = 0
          this.time = setInterval(() => {
            c++
            if(c>59){
              c=0
              b++
            }
            if(b>59){
              b=0
              a++
            }
            if(c<10){
              cc='0'+c
            }else{
              cc=c
            }
            if(b<10){
              bb='0'+b
            }else{
              bb=b
            }
            if(a<10){
              aa='0'+a
            }else{
              aa=a
            }
            console.log(aa,bb,cc)
            this.date=aa+':'+bb+':'+cc
          }, 1000);
        }
      },
      bbb(item){
        if(item.questType==2){
          if(item.radio.length==0){
            item.color='mr'
          }else{
            item.color='lvse'
          }
        }else{
            item.color='lvse'
        }
      },
      aaa(){
        console.log(this.dataList)
        this.dataList.forEach((item,index)=>{
          if(item.radio==''){
            this.noDone.push(index+1)
          }
        })
        if(this.noDone!=''){
          this.$message({
            type:'error',
            message:this.noDone.splice(',')+'题没有作答！'
          })
        }else{
          this.dataList.forEach((item,index)=>{
          if(item.questType==2){
            item.radio.forEach((itemA,indexA)=>{
              if(item.answer.split(',').indexOf(itemA)==-1){
                item.color='red'
              }
            })
            if(item.radio.length!=item.answer.split(',').length){
              item.color='red'
            }
          }else{
            if(item.radio!=item.answer){
              item.color='red'
            }
          }
        })
        let numList=[]
        this.dataList.forEach((item,index)=>{
          if(item.color=='lvse'){
            numList.push(item)
          }
        })
        // console.log(numList.length ,this.dataList.length)
        console.log()
        this.dialogVisible=true
        this.num = (numList.length / this.dataList.length).toFixed(2)*100
        if(this.time!=null){
        clearInterval(this.time)
      }
        myHttp.partyExam({
            personId:util.session.get('user').id,
            examScore:this.num,
            handTime:util.myTime.getAllTimeNew(),
            projectId:util.session.get('groupId'),
            partyExamType:2,
            paperId : this.$route.query.storeId
          }).then(res=>{
            console.log(res)
          })
        }
      },
      getRandomQuestion(){
        myHttp.getRandomQuestion(this.search).then(res=>{
          console.log(res)
          if(res.data.code==200){
            res.data.data.forEach((item,index)=>{
              if(item.questType==2){
                item.radio = []
                item.color = 'mr'
              }else{
                item.radio = ''
                item.color = 'mr'
              }
              
            })
            this.dataList = res.data.data
          }
        })
      },
      activeIndex(item,index){
        if(this.time==null){
          this.search.newsType = item.value
          this.active=index
          this.indexA = 0
          this.getData()
        }else{
          this.$confirm('切换将丢失本次考试数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            clearInterval(this.time)
            this.search.newsType = item.value
            this.active=index
            this.disabled=true
            this.getData()
          }).catch(() => {         
          })
        }
      },
    }
  }
</script>

<style scoped>
  .home-box{
    width: 100%;
    height: 100%;
    background-color: rgb(245,245,245);
    padding: 10px 24px 10px 16px;
  }
  .box{
    width: 100%;
    height: 100%;
    border-radius: 0px 0px 6px 6px;
    overflow: hidden;
  }
  .box-title{
    position: relative;
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
  }
  .box-title>div{
    position: absolute;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    cursor: pointer;
    left: 1%;
    top: 0;
  }
  .box-title>div:hover{
    opacity: 0.7;
  }
  .title-active{
    border-bottom: 2px solid #4D6EB1;
  }
  .box-title1{
    margin-top:1.1vh;
    height: 5.5vh;
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
  }
  .t1-l{
    height: 100%;
    display: flex;
  }
  .btn{
    margin-top: 30px;
    width: 100%;
    height: 40px;
    border-radius: 4px;
    background: #3871E5;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #FFFFFF;
  }
  .btn:hover{
    opacity: 0.7;
    cursor: pointer;
  }
  .scroll{
    overflow: hidden;
    margin-top: 10px;
    border-radius: 6px;
background: #FFFFFF;
box-shadow: 2px 2px 6px 0px rgba(77, 110, 177, 0.2);
display: flex;
padding: 0 1.7vw;
padding-top: 3.5vh;
  }
  .s-l{
    flex: 1;
    overflow: auto;
  }
  .s-r{
    width:15.6vw;
    margin-left: 17px;
  }
  .s-r-b{
    background: #FAFAFA;
box-sizing: border-box;
border: 1px solid #E1E1E1;
  }
  .s-r-b-t{
    height: 47px;
    background: #F0F0F0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 13px;
  }
  .s-r-b-t-l{
    font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
  }
  .s-r-b-t-r{
    font-family: SourceHanSansCN-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
  }
  .s-r-b-b{
    display: flex;
    flex-wrap: wrap;
    padding: 0 6px 13px 6px;
  }
  .s-l-i{
    margin-bottom: 16px;
    padding-left: 16px;
    background: #FAFAFA;
box-sizing: border-box;
border: 1px solid #E1E1E1;
padding-bottom:16px;
  }
  .a-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
  }
  .a-title>span{
    font-family: PingFangSC-Regular;
font-size: 16px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
position: relative;
  }
  .a-title>span::before{
    content: " ";
    position: absolute;
    left: -12px;top: 0;
    width: 4px;
    height: 100%;
    background: #4D6EB1;
  }
  .a-row{
     margin-top: 13px;
    display: flex;
    justify-content: start;
    align-items: center;
  }
  .a-row-l{
    width: 20px;
height: 20px;
background: #FA001F;
font-family: SourceHanSansCN-Medium;
font-size: 16px;
font-weight: 500;
letter-spacing: 0em;
color: #FFFFFF;
  }
  .a-row-r{
    margin-left: 24px;
    font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #525252;
  }
  .a-row1{
    margin-top: 16px;
    display: flex;
    justify-content: start;
    align-items: center;
    padding-left:44px ;
  }
  .a-row-item{
    font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #525252;
  }
  .red{
    background-color: #FA001F;
    margin-top: 13px;
    width: 18px;
    height: 18px;
    margin-left: 10px;
    font-family: SourceHanSansCN-Medium;
font-size: 14px;
font-weight: 500;
letter-spacing: 0em;
color: #FFFFFF;
  }
  .lvse{
    background-color: #30980D;
    margin-top: 13px;
    width: 18px;
    height: 18px;
    margin-left: 10px;
    font-family: SourceHanSansCN-Medium;
font-size: 14px;
font-weight: 500;
letter-spacing: 0em;
color: #FFFFFF;
  }
  .mr{
    background-color: #D6D3D3;
    margin-top: 13px;
    width: 18px;
    height: 18px;
    margin-left: 10px;
    font-family: SourceHanSansCN-Medium;
font-size: 14px;
font-weight: 500;
letter-spacing: 0em;
color: #FFFFFF;
  }
  .dialog-footer{
    display: flex;justify-content: center;
    margin-top: 6vh;
  }
  .btn1{
    width: 74px;
height: 26px;
border-radius: 4px;
box-sizing: border-box;
border: 1px solid #D4D6D9;
font-family: PingFangSC-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #31373D;
display: flex;
justify-content: center;
align-items: center;
  }
  .btn1:hover{
    cursor: pointer;
    opacity: 0.7;
  }
  .zw{
    width: 100%;
    height: 100%;
    width: 100%;
    height: 100%;
    margin-top: 13%;
    font-size: 30px;
    color: #666666;
  }
</style>